export default "__VITE_ASSET__t24ZLVx8__"